export const IMAGE_STATUS = {
    NO_IMAGE: 0,
    IMAGE_FROM_PREVIOUS_YEAR: 1,
    IMAGE_FROM_PREVIOUS_TRIM: 2,
    MAIN_IMAGE: 3,
    PARTIAL_COLORIZED: 4,
    FULL_COLORIZED: 5,
};

export default {
    IMAGE_STATUS,
};
